import { DocumentSchema, FieldDataType } from 'src/app/modules/core/store/models/document.model';
import { Dataset, DatasetSubtype, DatasetType } from './dataset.model';
export interface FilterGroup {
  uId?: string;
  filters: Filter[];
  filterGroups: FilterGroup[];
  groupType: FilterGroupType;
  fromDatasetUId?: string;
  toDatasetUId?: string;
}

export interface Filter {
  uId?: string;
  field: string;
  operator: RuleOperator;
  value: any;
  options?: number;
  filterOptions?: { dateFilterOptions: DateFilterOptions } | { withinMeters: number } | { equalNoCase: boolean};
  displayValue?: any;
  dataType?: FieldDataType;
  fromSystemField?: string;
  toSystemField?: string;
}

export enum FilterGroupType {
  And = 1,
  Or
}

export enum RuleOperator {
  Equal = 1,
  NotEqual = 2,
  GreaterThan = 3,
  GreaterThanEqualTo = 4,
  LessThan = 5,
  LessThanEqualTo = 6,
  Contains = 7,
  Proximity = 8,
  DateIsWithinLast = 9,
  DoesNotContain = 10,
  DateIsNotWithinLast = 11,
  IsEmpty = 12,
  IsNotEmpty = 13,
  In = 14,
  DateIsWithinNext = 15,
  DateIsNotWithinNext = 16,
  DateIsGreaterThan = 17,
  DateIsLessThan = 18,
  ContainsNoCase = 19,
  DoesNotContainNoCase = 20,
  NotIn = 21,
  InASingleGeofence = 22,
  NotInASingleGeofence = 23,
  Intersects = 24,
  InBoundingBox = 25,
  InProximity = 26,
  NotInProximity = 27,
  EqualNoCase = 28,
  NotEqualNoCase = 29
}

export enum DateFilterOptions {
  None = 0,
  Hours = 1,
  Days = 2,
  Weeks = 3,
  Months = 4,
  Years = 5
}

export interface ProximityFilterSettings {
  withinMeters?: number;
  datasetUId?: string;
  datasetType?: DatasetType;
  datasetSubtype?: DatasetSubtype;
  geometryField?: string;
  filter?: FilterGroup;
  systemDataTableName?: string;
  schema: DocumentSchema;
  display?: string;
}

export const filterOptionKeys = {
  dateFilterOptions: 'dateFilterOptions',
  withinMeters: 'withinMeters'
};

export interface QueryMatchRule {
  uId?: string | null;
  datasetUId?: string | null;
  root: FilterGroup | null;
}
